var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "debt-selection-card" } },
    _vm._l(_vm.operations, function (operation, operationIndex) {
      return _c(
        "div",
        {
          key: `operation${operationIndex}`,
          staticClass: "credit-description",
        },
        [
          _c("div", { staticClass: "credit-info" }, [
            _c("div", { staticClass: "credit-title" }, [
              operation.type === "PARKING"
                ? _c("div", { staticClass: "credit-ref" }, [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("credit")))]),
                      operation.companyOperationId !== undefined
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  operation.companyOperationId
                                    ? _vm.$t("parking")
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v("N° " + _vm._s(operationIndex + 1))]),
                    ]),
                  ])
                : operation.type === "SME"
                ? _c("div", { staticClass: "credit-ref" }, [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("credit")))]),
                      operation.companyOperationId !== undefined
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  operation.companyOperationId
                                    ? _vm.$t("sme")
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", [
                      _c("span", [_vm._v("N° " + _vm._s(operationIndex + 1))]),
                    ]),
                  ])
                : _c("div", { staticClass: "credit-ref" }, [
                    _c("div", [
                      _c("span", [_vm._v(_vm._s(_vm.$t("credit")))]),
                      operation.companyOperationId !== undefined &&
                      operation.type === "PARKING"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  operation.companyOperationId
                                    ? _vm.$t("parking")
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      operation.companyOperationId !== undefined &&
                      operation.type === "MORTGAGE"
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  operation.companyOperationId
                                    ? _vm.$t("mortgage")
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      operation.complementaryOperation !== undefined &&
                      operation.companyOperationId !== undefined
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  operation.companyOperationId &&
                                    operation.complementaryOperation
                                      .companyOperationId
                                    ? "y"
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]),
                    _c("div", [
                      operation.complementaryOperation !== undefined
                        ? _c("span", [
                            _vm._v(
                              " " +
                                _vm._s(
                                  operation.complementaryOperation
                                    .companyOperationId
                                    ? "Consumo complementario"
                                    : ""
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                      _c("span", [_vm._v("N° " + _vm._s(operationIndex + 1))]),
                    ]),
                  ]),
              _c("div", { staticClass: "details-content" }, [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        operation._id === _vm.extendedOperationDetails
                          ? (_vm.extendedOperationDetails = "")
                          : (_vm.extendedOperationDetails = operation._id)
                      },
                    },
                  },
                  [_c("span", { staticClass: "fas fa-info-circle" })]
                ),
              ]),
              _c("div", [
                _c("span", { staticClass: "alert-content-title" }, [
                  _vm._v(
                    _vm._s(!operation.isActive ? "Operación desactivada" : "")
                  ),
                ]),
              ]),
            ]),
            _c(
              "div",
              {
                staticClass: "credit-details",
                class: { show: _vm.extendedOperationDetails === operation._id },
              },
              [
                operation.companyOperationId !== undefined &&
                operation.type === "MORTGAGE"
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("creditMortgage")) +
                          " " +
                          _vm._s(operation.companyOperationId) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                operation.companyOperationId !== undefined &&
                operation.type === "SME"
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("sme")) +
                          " " +
                          _vm._s(operation.companyOperationId) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                operation.companyOperationId !== undefined &&
                operation.type === "PARKING"
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("parking")) +
                          " " +
                          _vm._s(operation.companyOperationId) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                operation.complementaryOperation !== undefined
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("creditComplementary")) +
                          " " +
                          _vm._s(
                            operation.complementaryOperation.companyOperationId
                          ) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                operation.origin !== undefined && !_vm.clientId
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("origin")) +
                          " " +
                          _vm._s(operation.origin) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                operation.subType !== undefined && !_vm.clientId
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("subType")) +
                          " " +
                          _vm._s(operation.subType) +
                          " "
                      ),
                    ])
                  : _vm._e(),
                operation.lastInvestorName !== undefined && !_vm.clientId
                  ? _c("span", [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("investor")) +
                          " " +
                          _vm._s(operation.lastInvestorName) +
                          " "
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
          _c(
            "div",
            { staticClass: "fees-content" },
            _vm._l(operation.allPayments, function (payments, paymentIndex) {
              return _c("related-payments", {
                key: `payments-${paymentIndex}`,
                staticClass: "card-item shadowless fee-light-green p-0 mt-6",
                attrs: {
                  "payments-object": payments,
                  operation: operation,
                  "payments-map": _vm.paymentsMap,
                  "related-payment-id": `${operationIndex}-${paymentIndex}`,
                  "payment-index": paymentIndex,
                  "current-loading-payment": _vm.currentLoadingPayment,
                  "current-user-is-client": !!_vm.clientId,
                  "global-extended-payment": _vm.globalExtendedPayment,
                  "show-remove-late-charges": _vm.showRemoveLateCharges,
                  "collect-client-debt": _vm.collectClientDebt,
                  "all-check-boxes-are-disabled": _vm.allCheckBoxesAreDisabled,
                },
                on: {
                  "remove-late-charges": function ($event) {
                    return _vm.$emit("remove-late-charges", $event)
                  },
                  "undo-remove-late-charges": function ($event) {
                    return _vm.$emit("undo-remove-late-charges", $event)
                  },
                  "extend-payment": function ($event) {
                    return _vm.extendPayment(
                      $event || `${operationIndex}-${paymentIndex}`
                    )
                  },
                  change: function ($event) {
                    return _vm.$emit("change", $event)
                  },
                  "confirm-deselect-payment": function ($event) {
                    return _vm.$emit("confirm-deselect-payment", $event)
                  },
                },
              })
            }),
            1
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }